module.exports = __webpack_public_path__ + "static/media/trash.c3645b1d.svg";